var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFdms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-FDMS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FDMS",
    clipPath: "url(#clip-FDMS)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FDMS_colored",
    transform: "translate(160 174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 327,
    height: 180,
    transform: "translate(-20 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M8.5,0V2l.5.5.5.5V4l.5.5.5.5V6l.5.5.5-.5V5L11,4.5,10.5,4V3L10,2.5,9.5,2V0Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M243.5,0V1l-.5.5h-1l-.5-.5V0Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M274.5,0l-.5.5h-1l-.5.5-.5.5-.5-.5V0Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M288.5,0l-.5.5h-2l-.5-.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M297.5,0l-.5.5-.5-.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M225.5,2l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M273,3.5l-.5-.5V2l.5-.5.5.5V3Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M292,3.5h-1l-.5-.5V2l.5-.5h1l.5.5V3Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M233,4.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M240,4.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M228,5.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M231,5.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M12.5,9V8L12,7.5l-.5.5V9l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M13.5,11l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M252.5,55l-1-1-.5-1.5-.5-1.5-1-1-.5-1.5-.5-1.5-.5-1.5-.5-1.5-1-1-.5-1.5-.5-1.5-1-1-.5-1.5-.5-1.5-1-1-.5-1.5-.5-1.5-1-1-.5-1.5-1.5-.5,1-1-1.5-.5v-2l-1.5-.5,1-1-1.5-.5v-2l-.5-1.5-1.5-.5v-2l-1.5-.5,1-1-1.5-.5v-2l-.5-1.5-1-1-1.5-.5-1.5.5h-1l-1.5-.5H167l-1.5.5-1.5.5h-4l-1-1h-2l-1.5.5-1.5.5-1-1-1,1-1-1-1.5.5-1.5.5h-8l-1.5-.5-1.5-.5-1,1-1-1h-2l-1.5.5-1.5.5H120l-1-1h-6l-1,1h-4l-1-1H65l-1.5.5h-2l-1,1,.5,1.5v3l-1,1-1.5.5-1,1L57,20.5l-1,1L55.5,23l-1,1,1,1v2L55,28.5l-1,1L53.5,31l-1,1v2l-1,1L51,36.5,50.5,38,50,39.5l-1,1L48.5,42l-1,1L47,44.5v2l-1.5.5L45,48.5v1l1,1,.5-1.5,1-1,.5-1.5.5-1.5,1-1V42l1.5-.5.5-1.5,1-1,.5-1.5.5-1.5,1-1,1-1,.5-1.5.5-1.5,1-1,.5-1.5,1-1,.5-1.5h1v2l1.5.5,1.5-.5,1-1L64,25.5H62L60.5,25l.5-1.5.5-1.5,1-1,.5-1.5.5-1.5,1-1,.5-1.5,1.5-.5,1.5-.5h4l1.5.5h1l1.5-.5H98l1.5-.5,1.5-.5h82v-2l1.5.5h2l1.5.5h40l1.5.5.5,1.5.5,1.5,1,1,.5,1.5.5,1.5,1,1,.5,1.5.5,1.5,1,1,.5,1.5.5,1.5,1,1,1,1,1,1v2l1,1,.5,1.5.5,1.5,1,1,.5,1.5,1.5.5-1,1,1.5.5v2l1.5.5-1,1,1,1,.5,1.5.5,1.5,1,1,.5,1.5.5,1.5,1,1,.5,1.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M14.5,14V13l-.5-.5-.5.5v1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M16.5,20V18l-.5-.5-.5-.5V16l-.5-.5-.5.5v1l.5.5.5.5v2l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M294,23.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M232.5,25V24l-.5-.5h-2l-.5.5v1l.5.5h2Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M287,29.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M29,30.5l-.5-.5V29l.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M16.5,30l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M52.5,30l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M40,31.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M45,31.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M17.5,32l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M15.5,35V34l-.5-.5H14l-.5.5v1l.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M29.5,37l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M11.5,42V41l-.5-.5-.5.5v1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M40.5,46l-.5-.5-.5-.5.5-.5h1l.5-.5-.5-.5-.5-.5-.5-.5-.5.5-.5.5H38l-.5.5v1l.5.5h1l.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M297,43.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M10.5,45l.5-.5.5-.5-.5-.5-.5.5-.5.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M38.5,49l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M43.5,55l.5-.5.5-.5V53l.5-.5.5-.5-.5-.5-.5-.5-.5-.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M297,53.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M51,78.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M244,78.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M139.5,81l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M56,82.5H54l-.5-.5.5-.5h2l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M105,82.5H60l-.5-.5.5-.5h45l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M111,82.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M113,82.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M127,82.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M286,82.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M291.5,82l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M294.5,82l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M281,85.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M264,87.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M250,91.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M259,90.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M284,92.5l-.5-.5V91l.5-.5h1l.5.5-.5.5-.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M289,91.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M148,92.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M270,92.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M46,93.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M279,93.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M167,96.5l-.5-.5-.5-.5-.5-.5V94l.5-.5h1l.5.5v2Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M271,94.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M148,95.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M266,95.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M38,96.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M263,104.5l-.5-.5-.5-.5-.5-.5v-1l.5-.5.5-.5v-1l.5-.5h1l.5-.5V96l.5-.5.5.5v4l-.5.5h-1l-.5.5v3Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M272,96.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M295.5,97V96l-.5-.5-.5.5v1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M282.5,97l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M47,98.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M268,98.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M44,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M176,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M40,100.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M126,100.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M184,100.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M261,101.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M45,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M47,102.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M41,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M49,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M56,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M198,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M276,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M278,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M291,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M38,103.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M73,103.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M255,103.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M280,103.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M39,104.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M46,108.5H44l-.5-.5-.5-.5-.5-.5v-1l-.5-.5-.5-.5v-1l.5-.5.5.5.5.5.5.5v1l.5.5h3l.5-.5.5-.5.5-.5.5-.5.5-.5.5-.5h2l.5.5v2l-.5.5H49l-.5.5-.5.5H47l-.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M279,104.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M63,105.5H61l-.5-.5.5-.5h2l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M32,106.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M40,106.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M65,106.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M21,109.5l-.5-.5v-2l.5-.5.5.5v2Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M61,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M204,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M230,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M250,108.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M277,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M60,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M70,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M78,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M130,108.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M191,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M194,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M35,113.5l-.5-.5v-1l-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5.5.5.5.5.5.5.5.5v2Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M276,109.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M22,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M245,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M295.5,112l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M24,113.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M51,113.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M148,113.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M261,113.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M274,113.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M52,114.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M25,115.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M28,115.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M14,118.5H13l-.5-.5-.5-.5-.5-.5v-1l.5-.5h1l.5.5.5.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M26,117.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M283,117.5h-2l-.5-.5.5-.5.5-.5.5-.5h1l.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M36,117.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M39,117.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M272,117.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M54,119.5H53l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M271,119.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M287.5,121l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M42,122.5H41l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M269,122.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M290.5,123v-1l-.5-.5-.5.5v1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M268,124.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M62,125.5H61l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M220,125.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M292.5,126v-1l-.5-.5h-1l-.5.5v1l.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M63,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M46,127.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M266,127.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M238,128.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M243,128.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M33,129.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M35,129.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M244,129.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M281.5,131l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M236,136.5h-2l-.5-.5-.5-.5h-2l-.5-.5v-2l-.5-.5-.5-.5.5-.5h2l.5.5.5.5h2l.5.5.5.5.5.5v2Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M209.5,136l.5-.5.5-.5.5-.5h1l.5-.5-.5-.5-.5-.5-.5-.5h-2l-.5.5v1l-.5.5-.5-.5v-1l-.5-.5h-4l-.5.5v1l.5.5h2l.5.5-.5.5h-2l-.5.5.5.5h6Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M214.5,135l.5-.5h1l.5-.5-.5-.5-.5-.5-.5-.5h-1l-.5.5v2l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M221.5,136v-2l.5-.5.5-.5-.5-.5-.5.5-.5.5-.5.5v2l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M36,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M48,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M218.5,134l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M225,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M271,135.5l-.5-.5v-1l.5-.5h2l.5.5-.5.5h-1l-.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M47,136.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M93,137.5H92l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M218.5,136l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M46,137.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M254,137.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M40,138.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M44,138.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M255,138.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M292.5,138l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M210,139.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M232,139.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M217.5,142l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M231.5,142l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M237.5,142l-.5-.5h-4l-.5.5.5.5h4Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M274.5,145l.5-.5h2l.5-.5v-1l-.5-.5h-3l-.5-.5-.5-.5-.5.5v1l.5.5.5.5v1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M9,144.5l-.5-.5-.5-.5-.5-.5.5-.5h2l.5.5-.5.5-.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M145.5,145l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M158.5,145l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M264.5,154v-5l.5-.5h2l.5-.5v-1l.5-.5.5-.5.5-.5.5-.5-.5-.5h-9l-.5.5v2l-.5.5-.5.5-.5.5-.5-.5-.5-.5h-2l-.5.5.5.5.5.5v1l.5.5h2l.5-.5.5-.5h4l.5.5v1l-.5.5-.5.5v2l.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M141.5,146l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M163.5,146l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M30.5,147l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M124.5,147l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M271.5,151l.5-.5.5-.5.5-.5.5-.5.5-.5.5.5.5.5.5-.5v-2l-.5-.5h-1l-.5.5-.5.5h-1l-.5.5.5.5.5.5-.5.5-.5.5-.5.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M11,148.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M74.5,148l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M195.5,150l.5-.5.5-.5v-1l-.5-.5-.5.5v1l-.5.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M288.5,148l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M106.5,150v-1l-.5-.5-.5.5-.5.5-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M117.5,149l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M123.5,149l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M206.5,149l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M228.5,149l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M88.5,150l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M149.5,154v-2l.5-.5.5-.5v-1l-.5-.5-.5.5v1l-.5.5-.5.5-.5.5-.5.5.5.5.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M235.5,150l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M96.5,152l-.5-.5-.5-.5-.5-.5-.5.5.5.5.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M133.5,152v-1l-.5-.5-.5.5-.5.5-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M170.5,152v-1l-.5-.5-.5.5v1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M268.5,151l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M111.5,152l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M216.5,152l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M248.5,152l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M225.5,153l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M259.5,155v-2l-.5-.5h-1l-.5.5-.5.5-.5.5v1l.5.5h2Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M71.5,155v-1l-.5-.5H69l-.5.5.5.5h1l.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M89.5,155v-1l-.5-.5H88l-.5.5v1l.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M91.5,154l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M143,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M153,155.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M206.5,154l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M214.5,154l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M119,156.5h-1l-.5-.5v-1l.5-.5.5.5.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M158,155.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M197.5,155l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M224.5,155l-.5-.5-.5.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M10,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M122,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M154,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#aaa6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M9.5,0V2L9,2.5,8.5,2V0Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M10,4.5,9.5,4V3l.5-.5.5.5V4Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M11,6.5,10.5,6V5l.5-.5.5.5V6Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M12,9.5,11.5,9V8l.5-.5.5.5V9Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M13,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M62,16.5l-.5-.5-.5-.5-.5-.5.5-.5.5-.5-.5-.5-.5-.5V12l.5-.5.5-.5.5-.5.5.5.5.5.5-.5.5-.5h43l.5.5-.5.5H65l-.5.5-.5.5-.5.5v1l-.5.5-.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M135,11.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M138,11.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M229,12.5H187l-.5-.5.5-.5h40l.5-.5.5-.5h2l.5.5-.5.5-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M185,12.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M231,12.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M14,14.5l-.5-.5V13l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M74,15.5l-.5-.5-.5-.5H67l-.5.5-.5.5H65l-.5-.5.5-.5.5-.5.5-.5H85l.5-.5.5-.5.5.5.5.5.5-.5.5-.5h95l.5.5-.5.5H100l-.5.5-.5.5H75l-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M230,14.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M232,14.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M15,17.5l-.5-.5V16l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M231,16.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M233,16.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M56,28.5l-.5-.5V25l-.5-.5-.5-.5.5-.5.5-.5V22l.5-.5.5-.5.5-.5.5-.5V19l.5-.5.5-.5.5-.5h1l.5-.5.5-.5.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M64,17.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M16,20.5l-.5-.5V18l.5-.5.5.5v2Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M232,18.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M234,18.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M63,19.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M3,21.5,2.5,21V20l.5-.5H9l.5.5-.5.5H4l-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M62,21.5l-.5-.5V20l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M233,20.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M235,20.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M61,23.5l-.5-.5V22l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M234,22.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M236,22.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M60,25.5l-.5-.5V24l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M232,25.5h-2l-.5-.5V24l.5-.5h2l.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M235,24.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M237,24.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M59,27.5l-.5-.5V26l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M63,28.5H61l-.5-.5V26l.5-.5h3l.5.5v1l-.5.5-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M236,26.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M238,26.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M58,28.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M237,28.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M239,28.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M53,34.5l-.5-.5V32l.5-.5.5-.5V30l.5-.5.5-.5.5-.5.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M52,30.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M57,30.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M240,31.5l-.5-.5V30l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M56,32.5l-.5-.5V31l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M241,33.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M55,34.5l-.5-.5V33l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M242,35.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M52,36.5l-.5-.5V35l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M54,35.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M243,37.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M51,38.5l-.5-.5V37l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M53,37.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M244,39.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M52,39.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M50,40.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M245,41.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M49,42.5l-.5-.5V41l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M51,41.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M246,43.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M49,44.5H48l-.5-.5V43l.5-.5.5.5.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M247,45.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M47,45.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M48,46.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M248,47.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M46,47.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M47,48.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M45,49.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M249,49.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M46,50.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M43,55.5H42l-.5-.5.5-.5.5-.5V53l.5-.5.5-.5V51l.5-.5.5.5.5.5.5.5-.5.5-.5.5v1l-.5.5-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M250,51.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M251,53.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M252,55.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M42,57.5H41l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M253,57.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M254,59.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M41,59.5H40l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M264,79.5h-1l-.5-.5V78l-.5-.5-.5-.5V76l-.5-.5-.5-.5V74l-.5-.5-.5-.5V72l-.5-.5-.5-.5V70l-.5-.5-.5-.5V68l-.5-.5-.5-.5V66l-.5-.5-.5-.5V64l-.5-.5-.5-.5V62l-.5-.5-.5-.5.5-.5.5-.5.5-.5.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5v2l.5.5.5.5.5.5.5.5v2l.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M40,61.5H39l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M39,63.5H38l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M38,65.5H37l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M32,76.5l-.5-.5V74l.5-.5.5-.5V72l.5-.5.5-.5V70l.5-.5.5-.5V68l.5-.5.5-.5.5-.5.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M27,143.5,23.5,142l-2-3-2-3-2-3-2-3-2-3L12,123.5,10.5,120l-2-3-2-3L5,110.5l-2-3,2-2,4-1,4.5-.5,3.5.5,3.5,1.5,1,4,2,3,2,3h2v-3L26,109.5,24.5,106l-2-3,1-4,2-3L27,92.5,28.5,89l2-3L32,82.5l4-1,3.5.5,2.5-.5h5l.5-2.5L50,76.5,52.5,79,52,80.5h65l4.5.5-4.5.5,3,1h5L122.5,81l4.5-.5h5l3,1-3,1h5l4.5-.5,2.5-.5h5l4,1,4.5-.5,4.5-.5h5l4,1,4-1h85l-3-1H207l1-1h30l3-1-2-2,4-1,2.5,2.5h-3l3.5,1.5h15l1.5,3.5,1,4,2,3,1.5,3.5,1.5,3.5-2-2-2,2-2,3-1.5-.5-2-3-2-3L254.5,96l-1,4-1.5,3.5-2,3-4-1,.5,1.5-1.5,3.5-4.5-.5-3.5-1.5-4,1-4-1h-5l-4,1-4-1-4,1-4-1-3,2-4-1-4,1-4-1-3.5.5-4.5-.5-3.5.5-4.5-.5h-3l-4.5.5-3.5-.5-4,1-4-1-2.5,2.5-1,4,1,4-4.5.5-4.5.5,3.5,1.5,2.5,2.5,3,1,3.5.5,4.5-.5,3.5.5,4-1,4,1,4-1,4,1h3l4.5-.5,3.5.5,4-1,4,1,3.5-1.5,3.5.5,4-1,4,1h5l4-1,3,2,4,1,4,1,4-1,3,2,3,2,3,2,2.5,2.5,2.5,2.5,3,2,1.5-3.5,1.5-3.5.5-2.5,3.5-1.5,1.5-3.5,2-3,2-3,2-3,1.5-3.5,1.5-3.5,2-3,2-3h2l4.5.5,4.5.5v3l-1.5,3.5-2,3-1.5,3.5-2,3-2,3-2,3-1.5,3.5-1.5,3.5-2,3-2,3-2.5,2.5H240l-1.5-3.5-2-3-1.5-3.5-4-1H203l-3.5-.5-1,4,1,4,2.5,2.5h10l-3-1-4.5-.5h-3l.5-2.5h5l3,1,1.5.5,2-1,1.5-.5h5l4.5.5,1,4-2.5-.5-1.5-1.5-3.5-.5-3.5,1.5-3.5,1.5H31Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M31,78.5l-.5-.5V77l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M51.5,78l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M32,81.5H29l-.5-.5.5-.5.5-.5V79l.5-.5.5.5v1l.5.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M139,81.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M265,81.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M28,83.5l-.5-.5V82l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M56.5,82l-.5-.5H54l-.5.5.5.5h2Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M105.5,82l-.5-.5H60l-.5.5.5.5h45Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M111.5,82l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M113.5,82l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M127.5,82l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M266,83.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M280,102.5l-.5-.5-.5-.5h-1l-.5.5-.5.5-.5-.5-.5-.5h-1l-.5-.5-.5-.5-.5-.5V99l-.5-.5-.5-.5V96l-.5-.5-.5-.5V94l-.5-.5-.5-.5V92l-.5-.5-.5-.5V90l-.5-.5-.5-.5V88l-.5-.5-.5-.5V86l.5-.5.5.5.5.5.5-.5.5-.5.5-.5V84l.5-.5.5.5v1l.5.5.5.5-.5.5-.5.5.5.5h1l.5.5v1l.5.5.5.5v1l.5.5.5.5v2l.5.5.5.5.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5.5.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M27,85.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M267,85.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M26,87.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M259.5,90V87l-.5-.5-.5.5v2l-.5.5-.5.5.5.5h1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M198.5,102l.5-.5.5-.5V99l.5-.5.5.5.5.5.5.5v1l.5.5h5l.5-.5V99l.5-.5.5.5.5.5.5.5v1l.5.5h4l.5-.5.5-.5.5-.5V99l.5-.5.5.5.5.5.5.5v1l.5.5h4l.5-.5v-1l.5-.5h2l.5.5v1l.5.5h4l.5-.5v-1l.5-.5h1l.5.5.5.5.5.5.5.5h1l.5-.5.5-.5h2l.5-.5V99l.5-.5.5.5.5.5.5.5.5.5h4l.5-.5.5-.5.5-.5.5-.5h2l.5-.5-.5-.5h-1l-.5-.5V94l-.5-.5-.5-.5V92l.5-.5.5-.5-.5-.5-.5.5-.5.5-.5-.5V88l-.5-.5h-5l-.5.5-.5.5h-1l-.5-.5-.5-.5h-4l-.5.5-.5.5h-2l-.5-.5-.5-.5h-4l-.5.5-.5.5h-2l-.5-.5-.5-.5h-3l-.5.5-.5.5-.5.5-.5.5-.5-.5-.5-.5h-1l-.5-.5-.5-.5h-3l-.5.5-.5.5-.5.5-.5.5-.5-.5-.5-.5h-6l-.5.5-.5.5-.5-.5-.5-.5h-5l-.5.5-.5.5h-1l-.5-.5-.5-.5h-5l-.5.5v1l-.5.5-.5-.5-.5-.5-.5-.5-.5-.5h-4l-.5.5-.5.5-.5.5-.5.5-.5-.5-.5-.5-.5-.5-.5-.5h-4l-.5.5-.5.5h-1l-.5-.5-.5-.5h-4l-.5.5-.5.5-.5.5-.5.5-.5-.5-.5-.5-.5-.5-.5-.5h-4l-.5.5v12l.5.5.5.5.5.5h3l.5-.5v-2l.5-.5.5-.5V98l.5-.5.5.5v1l.5.5.5.5v2l.5.5h4l.5-.5v-2l.5-.5.5-.5V98l.5-.5.5.5v3l.5.5.5.5.5.5h3l.5-.5v-2l.5-.5.5-.5V98l.5-.5.5.5.5.5.5.5v2l.5.5.5.5.5.5h3l.5-.5v-1l.5-.5.5-.5V98l.5-.5.5.5v1l.5.5.5.5v1l.5.5.5.5.5.5h3l.5-.5v-2l.5-.5.5-.5.5-.5.5.5v1l.5.5.5.5v1l.5.5h3Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M25,89.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M44.5,139l.5-1.5,1,1,1-1,1-1v-2l1.5-.5V124l.5-1.5h2l.5,1.5.5,1.5,1,1h4l1.5-.5,1.5-.5,1.5.5,1.5.5h2l1.5-.5,1.5-.5,1,1H88l1-1,1.5.5,1.5.5h16l1.5-.5h1l1.5.5h2l1.5-.5,1.5-.5,1,1h4l1-1h2l1,1h4l1-1,1,1h2l1-1,.5-1.5,1-1,1.5-.5h2l1-1,1.5-.5-1.5-.5-.5-1.5v-2l.5-1.5.5-1.5-.5-1.5-.5-1.5-1-1-1.5-.5h-2l-1,1h-2l-1-1h-2l-1.5.5-1.5.5-1.5-.5-1.5-.5h-2l-1,1h-2l-1-1h-4l-1,1-1.5-.5-1.5-.5h-2l-1.5.5-1.5.5-1-1h-2l-1.5.5-1.5.5H97l-1-1H94l-1,1H91l-1-1H86l-1,1H83l-1-1H80l-1.5.5-1.5.5-1.5-.5-1.5-.5H72l-1,1H69l-1-1H66l-1.5.5-1.5.5-1.5-.5-1.5-.5H58l-1,1-.5,1.5-.5,1.5-1-1-1-1-.5-1.5.5-1.5,1.5-.5-1.5-.5-1-1-.5-1.5.5-1.5h2l1-1,1,1h4l1.5-.5,1-1h1l1,1,1.5.5,1-1h2l.5-1.5h1l1,1,.5,1.5h2l1.5-.5,1-1,1-1h1l.5,1.5h4l1.5-.5.5-1.5,1.5.5.5,1.5h4l1-1,.5-1.5h1l1,1,.5,1.5h4l.5-1.5,1-1h1v2l1.5.5h4l.5-1.5.5-1.5,1.5.5v2l1.5.5h2l1.5-.5,1-1,.5-1.5,1.5.5v2l1.5.5h2l1.5-.5v-2l1-1h1l.5,1.5.5,1.5,1.5.5h2l1.5-.5v-2l.5-1.5,1-1,.5,1.5v2l.5,1.5h4l.5-1.5.5-1.5.5-1.5V90l-1-1-1.5-.5h-2l-1,1-1,1-1.5-.5-1.5-.5-1-1h-2l-1,1-1,1-1-1h-6l-1,1-1-1h-4l-1.5.5-.5,1.5-1-1-1-1h-4l-1.5.5h-1l-1.5-.5H96l-1,1L93.5,90,92,89.5H88l-1,1-1-1H82l-1.5.5-1.5.5L77.5,90,76,89.5H74l-1.5.5-1.5.5-1-1H66l-1,1H63l-1-1H58l-1,1H55l-1-1-1.5.5-1.5.5-1.5.5v2l-1,1v2L48,97.5l-1.5.5,1.5.5.5,1.5v2l1,1-.5,1.5-1,1-1,1H45l-1.5-.5-.5-1.5-1-1-.5-1.5-1-1L40,99.5,39.5,98l-1-1L38,95.5l-1-1L36.5,96l-1,1L35,98.5l-.5,1.5-1,1v2l-1,1-.5,1.5-.5,1.5v2l1,1,1,1,1,1,.5,1.5.5,1.5v2l1,1v10h-1l-1.5-.5-1.5.5-1,1,.5,1.5.5,1.5,1,1,1,1,1,1,.5,1.5,1,1,1.5.5,1.5.5,1,1h2Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M250.5,91V90l-.5-.5-.5.5-.5.5-.5.5.5.5h1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M24,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M23,93.5l-.5-.5V92l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M148.5,92l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M46.5,93l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M22,95.5l-.5-.5V94l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M148.5,95l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M21,97.5l-.5-.5V96l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M19,97.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M20,99.5l-.5-.5V98l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M265,113.5h-3l-.5-.5-.5-.5-.5-.5v-1l.5-.5.5-.5v-2l.5-.5.5-.5v-2l.5-.5.5-.5v-3l.5-.5h4l.5-.5V98l.5-.5.5.5v1l.5.5.5.5v1l-.5.5-.5.5v2l-.5.5-.5.5v1l-.5.5-.5.5v2l-.5.5-.5.5v1l-.5.5-.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M44.5,99l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M18,102.5H16l-.5-.5-.5-.5H14l-.5-.5.5-.5h4l.5-.5.5-.5.5.5v1l-.5.5-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M45.5,101l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M47.5,102v-1l-.5-.5-.5.5v1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M13,103.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M21,104.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M39,106.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M76.5,108l-.5-.5H66l-.5-.5v-1l-.5-.5H64l-.5-.5-.5-.5H61l-.5.5v2l-.5.5-.5.5.5.5H76Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M254,105.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M40,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M204.5,108v-1l-.5-.5-.5.5v1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M227.5,107l-.5-.5H209l-.5.5.5.5h18Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M230.5,107l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M127.5,108l-.5-.5H78l-.5.5.5.5h49Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M130.5,108l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M162.5,108l-.5-.5h-3l-.5.5.5.5h3Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M169.5,108l-.5-.5h-5l-.5.5.5.5h5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M191.5,108l-.5-.5H171l-.5.5.5.5h20Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M198.5,108l-.5-.5h-4l-.5.5.5.5h4Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M202.5,108l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M242,113.5l-.5-.5v-1l.5-.5h1l.5.5-.5.5-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M149.5,114v-1l-.5-.5h-1l-.5.5.5.5.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M54,116.5l-.5-.5-.5-.5H52l-.5-.5.5-.5.5-.5.5-.5h2l.5.5v1l-.5.5-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M14.5,118v-1l-.5-.5-.5-.5-.5-.5H12l-.5.5v1l.5.5.5.5.5.5h1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M283.5,117v-1l-.5-.5h-1l-.5.5-.5.5-.5.5.5.5h2Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M54,118.5H53l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M44,122.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M34,132.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M261,132.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M35,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M209,136.5h-6l-.5-.5.5-.5h2l.5-.5-.5-.5h-1l-.5-.5.5-.5.5-.5.5-.5h2l.5.5v1l-.5.5-.5.5.5.5.5-.5.5-.5.5.5.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M209,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M211,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M216,134.5h-1l-.5-.5v-1l.5-.5.5.5.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M222,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M228,136.5h-3l-.5-.5.5-.5.5-.5v-1l-.5-.5-.5-.5.5-.5h1l.5.5.5.5.5-.5.5-.5.5.5.5.5.5-.5.5-.5.5.5v1l-.5.5-.5.5-.5.5-.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M210,135.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M212,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M218,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M221,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M271.5,135l.5-.5h1l.5-.5-.5-.5h-2l-.5.5v1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M214,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M224,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M93.5,137v-1l-.5-.5-.5.5-.5.5-.5.5.5.5h1Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M218,136.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M221,136.5l-.5-.5.5-.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M237,140.5h-9l-.5-.5.5-.5h2l.5-.5-.5-.5h-4l-.5-.5.5-.5h5l.5-.5-.5-.5h-1l-.5-.5.5-.5h3l.5.5.5.5h2l.5.5v2l.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M232.5,139l-.5-.5-.5.5.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M217,142.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M231,142.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M237,142.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M283,3.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M257,5.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M262,5.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M247,7.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M256,7.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M268,8.5h-1l-.5-.5V7l.5-.5h1l.5.5V8Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M255,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M280,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M283,10.5l-.5-.5-.5-.5-.5-.5.5-.5.5-.5.5-.5.5.5.5.5.5.5-.5.5-.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M240,9.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M294,10.5h-1l-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M249,14.5h-2l-.5-.5V12l.5-.5.5-.5.5-.5h2l.5-.5.5-.5h1l.5.5-.5.5-.5.5-.5.5h-1l-.5.5v2Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M254,10.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M243,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M253,13.5h-1l-.5-.5V12l.5-.5h1l.5.5v1Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M261.5,14l.5-.5.5-.5.5-.5.5-.5-.5-.5h-1l-.5.5-.5.5-.5-.5-.5-.5-.5.5.5.5.5.5-.5.5-.5.5.5.5h1Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M288,13.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M257.5,14l-.5-.5-.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M287,14.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M295.5,19l.5-.5h1l.5-.5V17l-.5-.5-.5.5-.5.5-.5.5-.5.5-.5-.5-.5-.5-.5.5.5.5.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M267.5,19l-.5-.5-.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M294.5,23l-.5-.5-.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M287.5,30l.5-.5h1l.5-.5-.5-.5h-1l-.5-.5-.5-.5h-1l-.5.5v1l.5.5.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M297.5,45V42l-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M271.5,53V52l-.5-.5-.5.5v1l.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M269.5,54l-.5-.5-.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M271,64.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M274,64.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M278,67.5l-.5-.5V65l.5-.5.5.5v2Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M269,68.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M288.5,70l-.5-.5-.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M272,73.5l-.5-.5V72l.5-.5.5.5v1Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M274,72.5l-.5-.5.5-.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M274,74.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M266,146.5h-1l-.5-.5v-1l.5-.5.5.5.5.5.5.5Z",
    fill: "#edeceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M56,30.5l-.5-.5V29l.5-.5.5-.5V27l.5-.5.5-.5V25l.5-.5.5-.5V23l.5-.5.5-.5V21l.5-.5.5-.5V19l.5-.5.5-.5V17l.5-.5.5-.5V15l.5-.5.5-.5V13l.5-.5.5-.5.5-.5h47l.5-.5.5-.5h6l.5.5.5.5h29l.5-.5.5-.5h1l.5.5.5.5.5-.5.5-.5.5.5.5.5h1l.5-.5.5-.5h3l.5.5.5.5h5l.5-.5.5-.5h60l.5.5-.5.5H183l-.5.5-.5.5H85l-.5.5-.5.5H66l-.5.5-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M231,15.5l-.5-.5V14l-.5-.5-.5-.5V12l.5-.5.5.5.5.5.5.5v2Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M232,17.5l-.5-.5V16l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M233,19.5l-.5-.5V18l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M235,23.5l-.5-.5V22l-.5-.5-.5-.5V20l.5-.5.5.5.5.5.5.5v2Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M236,25.5l-.5-.5V24l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M237,27.5l-.5-.5V26l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M238,29.5l-.5-.5V28l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M239,30.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M55,32.5l-.5-.5V31l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M240,32.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M54,34.5l-.5-.5V33l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M241,34.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M53,36.5l-.5-.5V35l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M242,36.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M52,38.5l-.5-.5V37l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M243,38.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M51,40.5l-.5-.5V39l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M50,41.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M49,43.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M48,45.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M247,46.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M47,47.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M46,49.5l-.5-.5V48l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M248,48.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M249,50.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M250,52.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M251,54.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M40,60.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M39,62.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M259,140.5l-1.5-.5-1-1-1-1-1-1-1-1-1.5-.5-1-1-1-1-1.5-.5-1-1-1-1-1.5-.5-.5-1.5-1-1-1.5-.5h-8l-1.5-.5-1.5-.5h-2l-1-1-.5-1.5-1.5-.5-.5,1.5-1.5.5h-2l-1.5-.5h-1l-1.5.5h-2l-1.5-.5-1.5-.5-1-1-.5,1.5-1.5.5h-2l-1.5-.5-1.5-.5-1,1-1.5.5h-1l-1.5-.5h-2l-1.5.5-1.5.5-1-1h-2l-1.5.5-1.5.5h-2l-1-1h-2l-1.5.5-1.5.5-1.5-.5-1.5-.5-1.5.5-1.5.5h-2l-1-1h-2l-1,1h-2l-1.5-.5-1.5-.5-1.5.5-1.5.5-1.5-.5-1.5-.5h-4l-1.5-.5-1-1-1-1-1-1-1.5-.5v-1h6l1.5-.5.5-1.5,1-1h2l1.5-.5,1-1-1-1v-4h1l.5,1.5.5,1.5v2l.5,1.5h4l1.5-.5-1-1v-2l1-1h1v4l1.5.5h4l.5-1.5v-2l.5-1.5.5,1.5v2l1,1,1.5.5h2l1.5-.5v-4h1l1,1v2l.5,1.5h4l.5-1.5v-2l.5-1.5,1-1,.5,1.5v4l1.5.5h2l1.5-.5v-4l1.5-.5.5,1.5v2l1.5.5h4v-1l-.5-1.5.5-1.5,1.5.5.5,1.5.5,1.5,1.5.5h2l1.5-.5-.5-1.5v-1l.5-1.5h1l.5,1.5.5,1.5.5,1.5h4l.5-1.5v-2l.5-1.5,1,1,.5,1.5.5,1.5,1,1h4l.5-1.5-1-1v-2l.5-1.5,1-1,.5,1.5-1,1,1,1v2l1,1,1.5.5h2l.5-1.5v-2l.5-1.5,1,1,.5,1.5,1,1,.5,1.5h2l1.5-.5,1-1-1-1v-2h1l1,1h1l1-1-1-1,1.5-.5,1,1,1-1,.5-1.5,1-1-.5-1.5h-2v-1h2l1.5.5v2l.5,1.5,1-1,1-1,.5-1.5.5-1.5.5-1.5.5-1.5.5-1.5.5-1.5.5-1.5,1-1,.5-1.5,1-1,1,1,.5,1.5,1,1v2l1,1,.5,1.5.5,1.5,1,1v2l-.5,1.5-.5,1.5-.5,1.5-.5,1.5.5,1.5h4l.5-1.5,1-1,.5-1.5.5-1.5.5-1.5.5-1.5,1-1v-2l1-1-.5-1.5-.5-1.5-1-1-.5-1.5-.5-1.5-1-1-.5-1.5-.5-1.5-1-1V87l-1-1-.5-1.5-.5-1.5-1-1V80l1.5-.5,1.5.5.5,1.5.5,1.5,1,1,.5,1.5.5,1.5,1,1,.5,1.5.5,1.5.5,1.5.5,1.5,1,1,.5,1.5.5,1.5,1,1,.5,1.5,1,1,1,1h2l1-1,.5,1.5-1,1-.5,1.5-1,1-.5,1.5-1,1v2l-1,1-1,1-.5,1.5-.5,1.5-1,1-.5,1.5-.5,1.5-1,1-1,1-.5,1.5-.5,1.5-1,1-1,1v2l-1.5.5h-2l-1.5.5v2l-1,1v6Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M27,116.5l-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5v-1l-.5-.5-.5-.5-.5-.5-.5-.5v-1l-.5-.5-.5-.5v-2l-.5-.5-.5-.5v-1l.5-.5.5-.5-.5-.5-.5.5-.5.5H17l-.5-.5-.5-.5H14l-.5-.5v-1l.5-.5h1l.5.5.5.5h2l.5-.5.5-.5.5-.5v-1l.5-.5.5-.5V98l.5-.5.5-.5V96l.5-.5.5-.5V94l.5-.5.5-.5V92l.5-.5.5-.5V90l.5-.5.5-.5V88l.5-.5.5-.5V86l.5-.5.5-.5V84l.5-.5.5-.5V82l.5-.5h3l.5.5-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5v2l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5v1l.5.5.5.5-.5.5-.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M196,102.5h-1l-.5-.5v-2l-.5-.5-.5-.5V98l-.5-.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5-.5.5h-2l-.5-.5-.5-.5-.5-.5v-1l-.5-.5-.5-.5V98l-.5-.5-.5.5v1l-.5.5-.5.5v2l-.5.5h-3l-.5-.5-.5-.5-.5-.5V99l-.5-.5-.5-.5V96l-.5-.5-.5-.5V93l.5-.5h1l.5.5v3l.5.5h5l.5-.5V92l.5-.5.5.5.5.5.5.5v3l.5.5h5l.5-.5V92l.5-.5.5.5v1l.5.5.5.5v2l.5.5h5l.5-.5V93l-.5-.5-.5-.5.5-.5h1l.5.5v2l.5.5.5.5v1l.5.5h4l.5-.5V92l.5-.5h1l.5.5v3l.5.5h5l.5-.5V92l.5-.5h1l.5.5v2l.5.5.5.5.5.5h4l.5-.5V91l.5-.5.5.5v1l.5.5.5.5v1l.5.5.5.5.5.5h4l.5-.5V94l-.5-.5-.5-.5V92l.5-.5.5-.5.5-.5.5.5v2l.5.5.5.5v1l.5.5h2l.5-.5.5-.5.5.5.5.5.5-.5V91l.5-.5.5.5.5.5.5.5v1l.5.5.5.5v1l.5.5.5-.5.5-.5h3l.5.5.5.5.5.5-.5.5-.5.5.5.5.5.5-.5.5-.5.5-.5.5-.5.5-.5.5h-4l-.5-.5V99l-.5-.5h-1l-.5.5v1l-.5.5h-2l-.5.5-.5.5-.5-.5-.5-.5h-1l-.5-.5V99l-.5-.5-.5.5-.5.5-.5.5v1l-.5.5h-4l-.5-.5v-1l-.5-.5-.5-.5-.5-.5-.5.5-.5.5-.5.5v1l-.5.5h-4l-.5-.5v-1l-.5-.5-.5-.5-.5-.5-.5.5v1l-.5.5-.5.5-.5.5h-4l-.5-.5V99l-.5-.5h-1l-.5.5v2l-.5.5h-5l-.5-.5V99l-.5-.5h-1l-.5.5v2l-.5.5h-2l-.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M175,102.5h-3l-.5-.5-.5-.5-.5-.5V98l-.5-.5-.5-.5V92l.5-.5.5.5v4l.5.5h5l.5.5v1l-.5.5-.5.5v3Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M62,103.5H57l-.5-.5v-1l-.5-.5-.5.5v1l-.5.5H50l-.5-.5v-1l-.5-.5-.5-.5V98l.5-.5h5l.5-.5V96l.5-.5.5-.5V94l.5-.5.5.5v2l-.5.5-.5.5.5.5h6l.5-.5.5-.5.5.5.5.5h6l.5-.5V95l.5-.5.5.5v2l.5.5h5l.5-.5V96l.5-.5.5.5v1l.5.5h6l.5-.5V95l.5-.5.5.5v2l.5.5h5l.5-.5V96l.5-.5h1l.5.5v1l.5.5h5l.5-.5V94l.5-.5.5.5v2l.5.5h4l.5.5.5.5.5-.5.5-.5.5-.5V93l.5-.5.5.5v4l.5.5.5-.5.5-.5h12l.5-.5.5-.5.5.5v3l-.5.5-.5.5v2l-.5.5h-4l-.5-.5v-2l-.5-.5-.5-.5-.5-.5-.5.5v1l-.5.5-.5.5v1l-.5.5h-4l-.5-.5V99l-.5-.5-.5.5-.5.5-.5.5v1l-.5.5-.5.5-.5.5h-3l-.5-.5-.5-.5-.5-.5v-1l-.5-.5h-1l-.5.5v2l-.5.5H96l-.5-.5v-1l-.5-.5-.5-.5-.5-.5-.5.5-.5.5-.5.5v1l-.5.5H88l-.5-.5v-2l-.5-.5H86l-.5.5v2l-.5.5H80l-.5-.5v-1l-.5-.5H78l-.5.5v1l-.5.5H73l-.5-.5-.5-.5-.5-.5-.5-.5-.5.5-.5.5-.5.5-.5.5H65l-.5-.5v-1l-.5-.5-.5.5-.5.5-.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M168,102.5h-4l-.5-.5V99l-.5-.5-.5-.5V96l-.5-.5-.5-.5V93l.5-.5.5.5.5.5.5.5v3l.5.5h2l.5-.5.5-.5h1l.5.5.5.5.5.5v1l-.5.5-.5.5v2Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M94,94.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M124,94.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M49,134.5l-.5-1.5V123l-1.5-.5-.5,1.5v2h-1v-4l-1.5-.5-.5,1.5v2h-1v-2l-.5-1.5-1.5.5v4h-1v-8l-.5-1.5-1.5.5v12l-1.5.5v-1l.5-1.5V117l-1-1v-4l-.5-1.5-1-1-1-1-1.5-.5.5-1.5.5-1.5.5-1.5.5-1.5.5-1.5.5-1.5,1-1,.5-1.5.5-1.5h1l.5,1.5,1,1,.5,1.5.5,1.5.5,1.5,1,1v2l1,1,.5,1.5,1,1h2l1-1,1.5-.5,1.5-.5h2l1.5.5,1.5.5v1l-1.5.5v2l1,1-.5,1.5H52l-1-1v1l.5,1.5,1.5.5,1,1v1l-1.5.5.5,1.5,1.5-.5.5-1.5h4l1.5-.5,1-1v-4l.5-1.5,1,1,.5,1.5v4l1.5.5h2l1.5-.5v-4l-.5-1.5-1.5-.5,1.5-.5h2l.5,1.5v4l.5,1.5h4l.5-1.5v-4l.5-1.5,1,1,.5,1.5,1,1-1,1v2l1.5.5h2l1.5-.5v-6h1l1,1,.5,1.5v1l-.5,1.5.5,1.5h4l.5-1.5,1-1v-2l-1-1,.5-1.5,1.5.5.5,1.5.5,1.5-1,1,.5,1.5,1,1h4l.5-1.5v-4h1v4l1,1,1.5.5h2l1.5-.5v-4l-.5-1.5v-1l1.5.5.5,1.5.5,1.5v2l.5,1.5h4l1-1,1.5.5,1.5.5,1-1h2l.5-1.5v-4h1l.5,1.5.5,1.5v2l1,1,1.5.5h2l1-1,.5-1.5.5-1.5,1.5.5v2l.5,1.5,1.5-.5,1.5-.5,1.5-.5v-2l.5-1.5,1,1,.5,1.5v2l1.5.5h2l1.5.5v2l-.5,1.5-1,1h-2l-1,1-1,1-.5,1.5-1.5.5-1.5-.5-1.5-.5-1,1h-2l-1.5-.5-1.5-.5h-2l-1,1h-2l-1-1h-2l-1,1h-2l-1.5-.5-1.5-.5-1.5.5-1.5.5h-2l-1-1-1.5.5-1.5.5H99l-1.5-.5-1.5-.5-1,1H91l-1-1-1.5.5-1.5.5H77l-1-1-1.5.5-1.5.5H71l-1.5-.5-1.5-.5-1,1H65l-1.5-.5-1-1-1.5-.5-1,1-1,1H55l-1.5-.5-1-1v-2l-1.5-.5-1.5.5v10Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M131,102.5h-4l-.5-.5v-2l-.5-.5-.5-.5V97l.5-.5h5l.5-.5.5-.5.5.5v2l-.5.5-.5.5v3Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M268,100.5h-2l-.5-.5V96l.5-.5.5.5.5.5.5.5v1l.5.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M138,102.5h-4l-.5-.5V97l.5-.5h4l.5.5v5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M160,102.5h-3l-.5-.5-.5-.5-.5-.5V97l.5-.5h5l.5.5v2l-.5.5-.5.5v2Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M249,98.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M40.5,107v-1l-.5-.5-.5-.5v-1l-.5-.5-.5-.5-.5-.5-.5.5.5.5.5.5v2l.5.5.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M255.5,103l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M254.5,105l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M66,108.5H61l-.5-.5.5-.5.5-.5-.5-.5-.5-.5.5-.5h3l.5.5.5.5.5.5.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M209,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M213,107.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M220,107.5h-5l-.5-.5.5-.5h5l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M227,107.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M83,108.5H82l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M88,108.5H87l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M90,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M97,108.5H95l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M112,108.5H101l-.5-.5.5-.5h11l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M119,108.5h-5l-.5-.5.5-.5h5l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M124,108.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M127,108.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M161,108.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M168,108.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M183,108.5H172l-.5-.5.5-.5h11l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M190,108.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M197,108.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M202,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M195,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M65,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M97,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M126,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M168,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M113,114.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M149,114.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M128.5,120l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M162.5,120l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M169.5,120l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M176.5,120l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M183.5,120l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M205.5,120l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M212.5,120l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M220.5,120l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M62.5,121l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M70.5,121l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M77.5,121l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M91.5,121l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M98.5,121l-.5-.5-.5.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M35,128.5H33l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M32,130.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M33,131.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M34,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M203,134.5l-.5-.5v-1l.5-.5h1l.5.5-.5.5-.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M210,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M214,134.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M229,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M35,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M211,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M224,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M36,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M207,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M209,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M221,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M225,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M230,135.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M47,137.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M39,138.5l-.5-.5.5-.5.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M43,139.5H41l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1f2127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M85,13.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M87,13.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M259,89.5l-.5-.5V87l.5-.5.5.5v2Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M192,96.5h-5l-.5-.5V93l-.5-.5-.5-.5-.5-.5-.5.5v4l-.5.5h-5l-.5-.5V93l-.5-.5h-1l-.5-.5.5-.5.5-.5.5-.5.5-.5V89l.5-.5h1l.5.5.5.5h3l.5.5.5.5.5-.5.5-.5.5-.5.5-.5.5.5.5.5h3l.5.5.5.5h1l.5-.5.5-.5h7l.5-.5.5-.5.5.5.5.5h6l.5-.5.5-.5.5.5.5.5.5-.5.5-.5.5.5.5.5h2l.5.5.5.5.5-.5V89l.5-.5h4l.5.5.5.5h1l.5-.5.5-.5h6l.5.5.5.5.5-.5.5-.5.5-.5.5-.5.5.5.5.5h4l.5.5.5.5.5-.5V88l.5-.5h1l.5.5.5.5h3l.5.5-.5.5-.5.5-.5.5h-2l-.5.5v2l-.5.5-.5-.5V92l-.5-.5-.5-.5-.5-.5-.5.5v2l-.5.5-.5-.5V92l-.5-.5-.5-.5-.5-.5-.5.5-.5.5-.5.5v2l.5.5h1l.5.5-.5.5h-2l-.5-.5V94l-.5-.5-.5-.5V91l-.5-.5-.5.5-.5.5-.5.5v1l-.5.5-.5-.5V91l-.5-.5-.5.5-.5.5h-1l-.5.5v2l-.5.5-.5-.5V93l-.5-.5-.5-.5V91l-.5-.5-.5.5v4l-.5.5h-1l-.5-.5.5-.5.5-.5V93l-.5-.5-.5-.5-.5-.5h-5l-.5.5v1l-.5.5-.5-.5V91l-.5-.5h-1l-.5.5-.5.5-.5-.5-.5-.5-.5.5v4l-.5.5-.5-.5V92l-.5-.5h-1l-.5.5v2l-.5.5-.5-.5V92l-.5-.5h-3l-.5.5v2l-.5.5-.5-.5V92l-.5-.5h-1l-.5.5-.5.5-.5-.5-.5-.5h-3l-.5.5v1l-.5.5-.5-.5V92l-.5-.5-.5.5v4Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M125,98.5l-.5-.5V96l-.5-.5-.5.5-.5.5-.5-.5V93l-.5-.5h-3l-.5.5v3l-.5.5h-3l-.5-.5V93l-.5-.5h-2l-.5.5-.5.5-.5.5v3l-.5.5-.5-.5V93l-.5-.5-.5.5v3l-.5.5-.5-.5V94l-.5-.5-.5-.5-.5-.5h-2l-.5.5v2l-.5.5-.5.5-.5.5-.5-.5V94l-.5-.5-.5.5v3l-.5.5H95l-.5-.5V96l-.5-.5H93l-.5.5v1l-.5.5H87l-.5-.5V95l-.5-.5-.5.5v2l-.5.5H79l-.5-.5V96l-.5-.5-.5.5v1l-.5.5H72l-.5-.5V95l-.5-.5-.5.5v2l-.5.5H64l-.5-.5-.5-.5-.5.5-.5.5H56l-.5-.5.5-.5.5-.5V94l-.5-.5-.5.5v1l-.5.5-.5.5v1l-.5.5H53l-.5-.5.5-.5.5-.5V94l-.5-.5H51l-.5-.5V91l.5-.5h5l.5.5.5.5.5-.5.5-.5h5l.5.5.5.5h1l.5-.5.5-.5h5l.5.5.5.5.5-.5.5-.5h5l.5.5.5.5.5-.5.5-.5h6l.5.5.5.5.5-.5.5-.5h6l.5.5v1l.5.5.5-.5V91l.5-.5h5l.5.5.5.5.5-.5.5-.5h1l.5-.5.5-.5h2l.5.5.5.5h1l.5.5.5.5.5-.5.5-.5.5-.5.5-.5h3l.5.5.5.5.5.5.5.5h1l.5-.5V90l.5-.5h2l.5.5.5.5h2l.5.5.5.5.5-.5.5-.5.5-.5.5-.5h3l.5.5.5.5h1l.5.5.5.5.5-.5V90l.5-.5h4l.5.5v1l-.5.5h-1l-.5.5-.5.5h-1l-.5.5v1l-.5.5-.5.5v2l-.5.5-.5-.5V96l-.5-.5-.5.5-.5.5-.5-.5V93l-.5-.5h-3l-.5.5v3l-.5.5-.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M177,97.5l-.5-.5-.5-.5h-5l-.5-.5V92l-.5-.5-.5.5v5l-.5.5-.5-.5V93l-.5-.5h-4l-.5.5-.5.5-.5-.5-.5-.5-.5.5v2l.5.5.5.5v1l-.5.5-.5-.5-.5-.5-.5-.5V93l-.5-.5h-4l-.5-.5V90l.5-.5h4l.5.5.5.5.5.5.5.5.5-.5.5-.5.5-.5.5-.5h4l.5.5.5.5h1l.5-.5.5-.5h4l.5.5.5.5.5.5-.5.5h-4l-.5.5v3l.5.5h3l.5-.5V93l.5-.5.5.5v2l.5.5.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M191.5,95V93l-.5-.5-.5-.5-.5-.5h-1l-.5.5-.5.5-.5.5v2l.5.5h3Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M61.5,96V93l-.5-.5-.5.5-.5.5H58l-.5.5v2l.5.5h3Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M83.5,96l.5-.5.5-.5V93l-.5-.5H81l-.5.5v1l-.5.5-.5.5v1l.5.5h3Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M91.5,96l-.5-.5-.5-.5.5-.5.5-.5V93l-.5-.5H89l-.5.5v2l-.5.5-.5.5.5.5h3Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M99.5,96V93l-.5-.5H97l-.5.5-.5.5-.5.5v2l.5.5h3Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M183.5,95V93l-.5-.5h-3l-.5.5v2l.5.5h3Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M200,96.5h-5l-.5-.5V95l.5-.5.5.5.5.5h3l.5-.5V93l.5-.5.5.5v3Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M218,94.5l-.5-.5V93l.5-.5.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M49,95.5l-.5-.5V94l.5-.5.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M68.5,96V94l-.5-.5H66l-.5.5v2l.5.5h2Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M75.5,96l.5-.5.5-.5V94l-.5-.5H73l-.5.5v2l.5.5h2Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M94.5,94l-.5-.5-.5.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M124.5,94l-.5-.5-.5.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M129,94.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M231,95.5h-4l-.5-.5.5-.5h3l.5-.5.5-.5.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M256,94.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M219,95.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M238,95.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M242,95.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M247,95.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M156,96.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M207,96.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M255,96.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M107,97.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M166,97.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M247,97.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M193,98.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M248,98.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M110,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M209,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M232,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M240,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M87,100.5H86l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M101,100.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M194,100.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M64,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M78,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M93,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M234,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M253,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M63,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M70,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M103,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M108,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M191,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M197,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M76,103.5H74l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M252,104.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M210,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M214,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M222,107.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M247,108.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M249,109.5l-.5-.5v-2l.5-.5.5.5v2Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M251,107.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M69,108.5H67l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M76,108.5H71l-.5-.5.5-.5h5l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M81,108.5H79l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M86,108.5H84l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M89,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M94,108.5H91l-.5-.5.5-.5h3l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M100,108.5H98l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M113,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M122,108.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M125,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M162,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M169,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M171,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M184,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M196,117.5h-4l-.5-.5v-5l-.5-.5-.5.5-.5.5-.5.5v4l-.5.5h-4l-.5-.5v-3l-.5-.5-.5-.5-.5-.5-.5.5v4l-.5.5h-4l-.5-.5-.5-.5-.5-.5v-3l-.5-.5-.5.5v4l-.5.5h-5l-.5-.5v-4l-.5-.5-.5.5-.5.5-.5.5v2l.5.5.5.5-.5.5h-5l-.5-.5v-4l-.5-.5-.5-.5v-1l.5-.5.5-.5.5-.5h4l.5.5v1l.5.5.5-.5.5-.5.5-.5.5-.5h4l.5.5.5.5h2l.5-.5.5-.5h3l.5.5.5.5h2l.5-.5.5-.5h3l.5.5.5.5h2l.5-.5.5-.5h2l.5.5.5.5.5-.5.5-.5.5.5.5.5h1l.5-.5.5-.5h4l.5.5.5.5h1l.5-.5.5-.5h9l.5-.5.5-.5.5.5.5.5h3l.5-.5.5-.5h3l.5.5.5.5h1l.5.5-.5.5-.5.5v3l.5.5.5.5v1l-.5.5h-4l-.5-.5-.5-.5-.5-.5v-2l-.5-.5-.5-.5-.5-.5-.5.5v4l-.5.5h-4l-.5-.5v-2l-.5-.5-.5-.5v-1l-.5-.5-.5.5v1l-.5.5-.5.5.5.5.5.5v1l-.5.5h-4l-.5-.5v-1l-.5-.5-.5-.5v-1l-.5-.5h-1l-.5.5v2l.5.5.5.5-.5.5h-5l-.5-.5v-3l-.5-.5h-1l-.5.5v4Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M239,116.5h-3l-.5-.5v-1l-.5-.5-.5-.5v-1l-.5-.5-.5-.5-.5-.5-.5.5v4l-.5.5h-3l-.5-.5-.5-.5-.5-.5v-2l-.5-.5-.5-.5.5-.5.5-.5v-2l.5-.5h3l.5.5.5.5.5.5.5.5.5-.5.5-.5h1l.5-.5.5-.5h2l.5.5.5.5.5.5v4l.5.5.5.5-.5.5-.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M60,117.5H55l-.5-.5.5-.5.5-.5v-2l.5-.5h1l.5-.5v-3l.5-.5h2l.5.5.5.5.5.5v5l-.5.5-.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M68,117.5H64l-.5-.5v-5l-.5-.5-.5-.5.5-.5h1l.5.5.5.5.5-.5-.5-.5-.5-.5.5-.5h3l.5.5-.5.5H67l-.5.5.5.5h1l.5.5v5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M75,117.5H71l-.5-.5v-6l.5-.5.5-.5.5-.5h3l.5.5v7Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M82,117.5H78l-.5-.5v-2l.5-.5.5-.5-.5-.5-.5-.5v-1l-.5-.5-.5-.5.5-.5h2l.5-.5.5-.5h1l.5.5.5.5.5.5v6Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M89,117.5H85l-.5-.5v-2l.5-.5.5-.5-.5-.5-.5-.5v-1l-.5-.5-.5-.5.5-.5h1l.5-.5.5-.5h2l.5.5.5.5.5.5v1l.5.5.5.5v2l-.5.5-.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M97,117.5H93l-.5-.5-.5-.5-.5-.5v-1l.5-.5.5-.5v-1l-.5-.5-.5-.5v-1l.5-.5h1l.5-.5.5-.5h1l.5.5.5.5.5.5.5.5.5.5v5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M104,117.5h-4l-.5-.5-.5-.5-.5-.5v-4l.5-.5.5-.5.5-.5.5-.5.5-.5h2l.5.5v1l.5.5.5.5v5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M115,117.5h-1l-.5-.5-.5-.5h-1l-.5.5-.5.5h-4l-.5-.5v-4l-.5-.5-.5-.5v-1l.5-.5h1l.5-.5.5-.5h3l.5.5.5.5h2l.5-.5.5-.5h3l.5.5v6l-.5.5h-2l-.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M140,117.5h-4l-.5-.5.5-.5h3l.5-.5v-2l-.5-.5h-4l-.5-.5-.5-.5-.5.5v3l-.5.5h-2l-.5.5-.5.5h-1l-.5-.5v-3l-.5-.5h-1l-.5.5v2l-.5.5-.5.5-.5.5h-3l-.5-.5-.5-.5-.5-.5v-3l-.5-.5-.5-.5v-1l.5-.5h1l.5-.5.5-.5h3l.5.5v1l.5.5.5-.5.5-.5h1l.5-.5.5-.5h2l.5.5.5.5h1l.5.5.5.5h1l.5-.5.5-.5h3l.5.5.5.5.5.5v5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M156,118.5l-.5-.5v-8l.5-.5h4l.5.5v5l.5.5.5.5-.5.5-.5.5-.5.5h-3l-.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M98,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M242,111.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M55,113.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M113.5,114v-1l-.5-.5-.5.5v1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M136,115.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M128,120.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M169,120.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M176,120.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M183,120.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M205,120.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M212,120.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M220,120.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M62,121.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M70,121.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M77,121.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M91,121.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M98,121.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M212,124.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M227,124.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M135,125.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M205,125.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M214,125.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M43,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M76,126.5H75l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M104,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M109,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M111,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M122,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M130,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M155,126.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M159,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M163,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M170,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M183,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M194,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M203,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M232,127.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M37,130.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M261,131.5l-.5-.5v-1l.5-.5h2l.5.5-.5.5h-1l-.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M33,132.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M260,134.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M209,134.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M36,136.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M48,136.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M38,137.5H37l-.5-.5.5-.5h1l.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M46,138.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M44,139.5l-.5-.5.5-.5.5.5Z",
    fill: "#1c3254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M241.5,0V1l.5.5h1l.5-.5V0Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M244.5,0l.5.5h1l.5-.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M253.5,0l.5.5.5-.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M260.5,0l.5.5.5-.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M285.5,0l.5.5h2l.5-.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M296.5,0l-.5.5-.5-.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M297,1.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M225,2.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M277.5,6l.5-.5.5-.5-.5-.5h-1l-.5-.5V3l.5-.5.5-.5-.5-.5h-1l-.5.5-.5.5-.5.5V4l.5.5h1l.5.5V6l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M281.5,5l.5-.5h2l.5-.5V2l-.5-.5h-1l-.5.5-.5.5-.5.5-.5.5-.5.5V5l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M297,3.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M233.5,4l-.5-.5-.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M231.5,5l-.5-.5-.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M265,6.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M239,7.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M266,7.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M269,7.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M241,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M243,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M281,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M246,9.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M249,10.5l-.5-.5V9l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M279,9.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M294,9.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M260,10.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M239,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M271,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M273,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M275,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M279,11.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M291,11.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M294,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M240,12.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M242,13.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M261,14.5l-.5-.5V13l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M292,13.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M295,13.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M252,16.5l-.5-.5V15l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M286,15.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M288,15.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M249,16.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M291,16.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M251,18.5h-1l-.5-.5V17l.5-.5.5.5.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M252,21.5l-.5-.5V19l.5-.5.5.5v2Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M254,22.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M257,25.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M258,26.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M259,28.5h-3l-.5-.5.5-.5h2l.5-.5.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M253,28.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M288,29.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M16,30.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M287,30.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M40.5,31l-.5-.5-.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M45.5,31l-.5-.5-.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M17,32.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M15,35.5H14l-.5-.5V34l.5-.5h1l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M29,37.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M11,42.5l-.5-.5V41l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M295,41.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M296,42.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M39,45.5H38l-.5-.5V44l.5-.5h1l.5-.5.5-.5.5.5.5.5.5.5-.5.5H40l-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M11,44.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M297,44.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M10,45.5,9.5,45l.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M40,46.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M38,49.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M258,56.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M260,60.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M261,62.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M280,71.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M284,71.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M276,73.5l-.5-.5V72l.5-.5h1l.5.5-.5.5-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M268,75.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M279,75.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M274,77.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M286.5,82l-.5-.5-.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M291,82.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M294,82.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M297,82.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M272,83.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M275,85.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M296,87.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M279.5,93l.5-.5h1l.5-.5-.5-.5-.5-.5-.5-.5-.5.5v1l-.5.5-.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M284.5,92l.5-.5.5-.5-.5-.5h-1l-.5.5v1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M295,97.5l-.5-.5V96l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M282,97.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M287,97.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M281,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M282,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M288,103.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M292,104.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M295,112.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M6,118.5H5l-.5-.5-.5-.5H3l-.5-.5.5-.5.5-.5v-1l.5-.5H5l.5.5.5.5.5.5v2Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M3,122.5l-.5-.5v-3l.5-.5H4l.5.5-.5.5-.5.5.5.5.5.5-.5.5-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M287,121.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M290,123.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M292,126.5h-1l-.5-.5v-1l.5-.5h1l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M281,131.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M292,138.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M5,141.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M277,144.5l-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M16,146.5l-.5-.5v-2l.5-.5h2l.5.5v1l-.5.5H17l-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M21,144.5H20l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M274,145.5l-.5-.5v-1l.5-.5h1l.5.5-.5.5-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M24,145.5H23l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M158,145.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M260,146.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M262,145.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M269,145.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M163,146.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M30,147.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M124,147.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M146,147.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M175,150.5h-2l-.5-.5v-2l.5-.5.5-.5.5-.5.5.5.5.5.5.5v2Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M267,148.5l-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M275,149.5l-.5-.5-.5-.5-.5.5-.5.5-.5-.5-.5-.5-.5-.5.5-.5h1l.5-.5.5-.5h1l.5.5v2Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M12,148.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M74,148.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M144,148.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M196,149.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M258,150.5l-.5-.5-.5-.5-.5.5-.5.5-.5-.5v-1l-.5-.5-.5-.5.5-.5h2l.5.5.5.5.5-.5.5-.5h1l.5.5.5.5h2l.5.5-.5.5h-4l-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M288,148.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M106,149.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M123,149.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M145,150.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M206,149.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M228,149.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M88,150.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M105,150.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M150,151.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M161,152.5l-.5-.5v-1l.5-.5h1l.5-.5.5-.5.5.5.5.5.5-.5.5-.5.5.5v1l-.5.5h-3l-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M195,150.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M235,150.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M264,154.5h-1l-.5-.5v-2l.5-.5.5-.5v-1l.5-.5.5.5v4Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M272,150.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M95,151.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M120,151.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M130,151.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M133,152.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M170,151.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M175,154.5l-.5-.5v-2l.5-.5.5-.5.5-.5.5.5.5.5.5.5-.5.5h-1l-.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M181,154.5l-.5-.5v-2l.5-.5h1l.5-.5.5-.5.5.5v1l-.5.5h-1l-.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M268,151.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M271,151.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M96,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M111,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M119,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M125,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M128,155.5l-.5-.5v-3l.5-.5h1l.5.5-.5.5-.5.5v2Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M145,154.5h-1l-.5-.5v-2l.5-.5.5.5v1l.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M149,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M173,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M248,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M98,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M117,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M123,153.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M148,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M178,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M184,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M186,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M259,155.5l-.5-.5-.5-.5h-1l-.5-.5.5-.5.5-.5.5-.5h1l.5.5v2Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M6,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M66,156.5H65l-.5-.5v-2l.5-.5.5.5.5.5h1l.5.5-.5.5-.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M71,155.5l-.5-.5-.5-.5H69l-.5-.5.5-.5h2l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M77,156.5H76l-.5-.5v-2l.5-.5.5.5.5.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M81,156.5H79l-.5-.5.5-.5.5-.5.5-.5.5-.5.5-.5.5.5v2Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M89,155.5H88l-.5-.5v-1l.5-.5h1l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M91,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M98,156.5H97l-.5-.5v-1l-.5-.5-.5-.5.5-.5h1l.5.5v1l.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M115,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M118,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M149,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M152,155.5l-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M154,155.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M173,156.5h-2l-.5-.5v-1l.5-.5.5-.5.5-.5.5.5v1l.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M188,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M193,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M105,156.5h-3l-.5-.5.5-.5h2l.5-.5.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M119,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M122,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M126,156.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M140,156.5h-4l-.5-.5.5-.5.5-.5.5-.5h2l.5.5.5.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M143,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M147,156.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M161,156.5h-1l-.5-.5-.5-.5-.5-.5.5-.5h2l.5.5v1Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M186,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M203,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M221,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M224,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M115,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M120,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M142,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M158,156.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M177,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M191,156.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M193,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M195,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M216,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M220,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M246,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M255,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M266,156.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c1bdb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M246.5,0l-.5.5h-1l-.5-.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M254.5,0l-.5.5-.5-.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M261.5,0l-.5.5-.5-.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M259,3.5l-.5-.5V2l.5-.5.5.5V3Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M258,5.5l-.5-.5V4l.5-.5.5.5V5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M224,7.5l-.5-.5-.5-.5h-1l-.5-.5.5-.5.5-.5.5-.5h1l.5.5.5.5.5.5-.5.5-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M241,5.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M296,6.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M230,8.5h-2l-.5-.5V7l.5-.5h1l.5.5.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M247.5,7l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M255,7.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M281,7.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M283,7.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M240.5,9l.5-.5.5-.5-.5-.5-.5.5-.5.5h-1l-.5.5.5.5h1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M243.5,8l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M269,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M279,8.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M282,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M296,8.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M246.5,9l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M263,9.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M259,10.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M240.5,12l-.5-.5-.5-.5-.5-.5-.5.5.5.5.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M243.5,11l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M257,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M271.5,11l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M274,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M283,11.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M260,12.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M242.5,13l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M274,13.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M292.5,13l-.5-.5h-1l-.5.5.5.5h1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M257,14.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M260,14.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M286,14.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M238,16.5l-.5-.5V15l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M287,15.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M288,16.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M294,18.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M267,19.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M295,19.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M255,23.5l-.5-.5V22l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M256,24.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M258,25.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M259,26.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M244,28.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M252,28.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M286,28.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M289,29.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M247,35.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M248,37.5l-.5-.5V36l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M249,39.5l-.5-.5V38l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M295,40.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M250,41.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M296,41.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M251,42.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M297,42.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M296,43.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M252,44.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M297,45.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M269,54.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M293,56.5l-.5-.5V54l.5-.5.5.5v2Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M270,58.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M261,61.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M277,61.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M270,64.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M278.5,67V65l-.5-.5-.5.5v2l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M269.5,68l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M288,70.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M280.5,71l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M284.5,71l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M274.5,74l-.5-.5h-1l-.5-.5V72l-.5-.5-.5.5v1l.5.5.5.5.5.5h1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M274.5,72l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M276.5,73l.5-.5.5-.5-.5-.5h-1l-.5.5v1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M279.5,75l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M274.5,77l-.5-.5-.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M289,78.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M288,85.5h-1l-.5-.5V84l.5-.5h1l.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M277,88.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M277,92.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M279,96.5l-.5-.5V95l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M282,100.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M283,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M295,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M288,102.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M4,118.5H3l-.5-.5.5-.5H4l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M5,142.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M275,143.5h-2l-.5-.5v-1l.5-.5.5.5.5.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M276,144.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M4,145.5H3l-.5-.5.5-.5H4l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M145,145.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M264,149.5l-.5-.5-.5-.5h-2l-.5-.5-.5-.5-.5-.5.5-.5.5-.5v-1l.5-.5.5.5.5.5.5-.5.5-.5h1l.5.5v1l.5.5.5.5.5.5.5.5-.5.5h-1l-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M268,146.5h-1l-.5-.5-.5-.5-.5-.5.5-.5h2l.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M141,146.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M10,148.5H9l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M12,147.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M145,147.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M117,149.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M144,149.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M106,150.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M119,151.5l-.5-.5v-1l.5-.5h1l.5.5-.5.5-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M162,150.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M257,150.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M141,156.5l-.5-.5-.5-.5-.5-.5v-3l.5-.5h1l.5-.5.5-.5h2l.5.5-.5.5-.5.5v1l-.5.5-.5.5v1l-.5.5-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M267,151.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M125,156.5h-2l-.5-.5v-2l.5-.5.5-.5v-1l.5-.5.5.5.5.5.5.5-.5.5-.5.5v1l.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M130,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M170,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M176,156.5h-2l-.5-.5-.5-.5-.5-.5v-2l.5-.5.5-.5.5-.5.5.5v2l.5.5.5-.5v-1l.5-.5h1l.5.5.5.5.5.5-.5.5-.5.5-.5.5-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M216,152.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M117,156.5h-1l-.5-.5-.5-.5-.5-.5.5-.5.5-.5v-1l.5-.5.5.5.5.5.5.5v2Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M119,154.5l-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M149,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M154,153.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M165,156.5h-3l-.5-.5v-1l-.5-.5h-4l-.5.5-.5.5-.5.5-.5.5-.5-.5v-2l.5-.5h2l.5-.5.5-.5h4l.5.5.5.5h3l.5.5v1l-.5.5-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M180,153.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M187,154.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M225,153.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M127,155.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M170,155.5l-.5-.5v-1l.5-.5h1l.5.5-.5.5-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M194,154.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M206,154.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M214,154.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M15,156.5H14l-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5.5.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M110,155.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M145,156.5h-2l-.5-.5.5-.5.5-.5.5-.5h2l.5.5-.5.5-.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M185,156.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M192,156.5l-.5-.5-.5-.5-.5-.5.5-.5h1l.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M197,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M202,156.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M217,155.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M258,155.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M78,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M101,156.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M108,156.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M121,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M153,156.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M159,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M189,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M221,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M240,156.5l-.5-.5.5-.5.5.5Z",
    fill: "#c4c1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M215,89.5h-2l-.5-.5-.5-.5-.5.5-.5.5-.5-.5-.5-.5-.5-.5.5-.5h3l.5.5.5.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M221,88.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M229,88.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M237,88.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M245,88.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M129,89.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M138,89.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M160,89.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M168,89.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M175,89.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M183,89.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M186,89.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M191,89.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M199,89.5h-5l-.5-.5.5-.5h5l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M201,89.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M207,89.5h-4l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M209,89.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M223,89.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M231,89.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M239,89.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M54,90.5H53l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M62,90.5H58l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M70,90.5H66l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M77,90.5H73l-.5-.5.5-.5h4l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M86,90.5H81l-.5-.5.5-.5h5l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M93,90.5H88l-.5-.5.5-.5h5l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M101,90.5H96l-.5-.5.5-.5h5l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M104,90.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M108,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M111,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M116,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M118,91.5h-1l-.5-.5.5-.5.5-.5.5-.5.5.5v1Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M124,90.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M126,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M131,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M139,99.5l-.5-.5V97l-.5-.5h-4l-.5-.5V95l.5-.5.5-.5V93l.5-.5h1l.5-.5.5-.5h1l.5-.5V90l.5-.5.5.5v9Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M161,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M163,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M170,90.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M176,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M178,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M193,90.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M216,90.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M247,94.5h-5l-.5-.5V91l.5-.5h2l.5-.5.5-.5.5.5v1l.5.5.5.5v1l.5.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M52,97.5H49l-.5-.5V96l.5-.5.5-.5V91l.5-.5.5.5v2l.5.5h2l.5.5v2l-.5.5-.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M57,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M65,91.5H64l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M72,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M79,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M87,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M95,92.5l-.5-.5V91l.5-.5.5.5v1Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M102,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M125,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M133,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M162,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M177,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M215,95.5h-4l-.5-.5V91l.5-.5.5.5.5.5.5-.5.5-.5h1l.5.5v2l.5.5.5.5v1Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M230,94.5h-3l-.5-.5V92l.5-.5h1l.5-.5.5-.5.5.5v2l.5.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M238,94.5h-3l-.5-.5V92l.5-.5.5-.5.5-.5.5.5.5.5.5.5v1l.5.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M247,91.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M175,95.5h-3l-.5-.5V92l.5-.5h4l.5.5-.5.5-.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M191,95.5h-3l-.5-.5V93l.5-.5.5-.5.5-.5h1l.5.5.5.5.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M199,95.5h-3l-.5-.5-.5-.5-.5-.5V92l.5-.5h3l.5.5.5.5.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M207,95.5h-4l-.5-.5V92l.5-.5h3l.5.5v2l.5.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M221,95.5h-1l-.5-.5-.5-.5-.5-.5V93l-.5-.5-.5-.5.5-.5h3l.5.5.5.5.5.5v1l-.5.5-.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M61,96.5H58l-.5-.5V94l.5-.5h2l.5-.5.5-.5.5.5v3Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M83,96.5H80l-.5-.5V95l.5-.5.5-.5V93l.5-.5h3l.5.5v2l-.5.5-.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M91,96.5H88l-.5-.5.5-.5.5-.5V93l.5-.5h2l.5.5v1l-.5.5-.5.5.5.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M99,96.5H96l-.5-.5V94l.5-.5.5-.5.5-.5h2l.5.5v3Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M107,96.5h-4l-.5-.5.5-.5.5-.5V93l.5-.5h2l.5.5.5.5.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M114,96.5h-3l-.5-.5V94l.5-.5.5-.5.5-.5h2l.5.5v3Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M122,96.5h-3l-.5-.5V93l.5-.5h3l.5.5v3Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M130,96.5h-3l-.5-.5V93l.5-.5h3l.5.5v3Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M160,96.5h-3l-.5-.5-.5-.5-.5-.5V93l.5-.5h4l.5.5v3Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M168,96.5l-.5-.5V94l-.5-.5h-1l-.5.5v1l.5.5.5.5-.5.5h-2l-.5-.5V93l.5-.5h4l.5.5v3Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M183,95.5h-3l-.5-.5V93l.5-.5h3l.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M68,96.5H66l-.5-.5V94l.5-.5h2l.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M75,96.5H73l-.5-.5V94l.5-.5h3l.5.5v1l-.5.5-.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M129.5,94l-.5-.5-.5.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M48,98.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M117,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M163,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M201,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M224,99.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M116,101.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M67,103.5H66l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M185,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M198,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M204,108.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M210,109.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M215,109.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M217,109.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M227,109.5h-2l-.5-.5.5-.5h2l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M235,109.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M61,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M79,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M82,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M90,110.5H89l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M96,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M104,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M107,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M114,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M132,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M139,110.5h-3l-.5-.5.5-.5h3l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M161,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M175,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M177,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M184,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M189,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M191,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M198,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M204,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M233,110.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M240,111.5l-.5-.5v-1l.5-.5.5.5v1Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M57,113.5l-.5-.5v-2l.5-.5.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M99,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M135,111.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M140,111.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M241,112.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M141,115.5l-.5-.5v-2l.5-.5.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M155,117.5l-.5-.5v-4l.5-.5.5.5v4Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M139,116.5h-3l-.5-.5.5-.5.5-.5-.5-.5-.5-.5.5-.5h3l.5.5v2Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M55,116.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M162,120.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M142,121.5h-1l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M147,121.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M45,122.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M140,122.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M48,123.5H47l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M97,126.5H96l-.5-.5.5-.5h1l.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M103,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M118,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M186,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M201,126.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M234,128.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M262,132.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M261,133.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M37,136.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M253,136.5l-.5-.5.5-.5.5.5Z",
    fill: "#294568"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdms);
export default __webpack_public_path__ + "static/media/FDMS.bf22b91efb2049964e7fa160414ae1fc.svg";
export { ForwardRef as ReactComponent };